import Vue from 'vue'
import App from './App.vue'
import i18n from './plugins/vue-i18n'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Axios from 'axios'
import { Model } from 'vue-api-query'
import './global'
import './plugins/vee-validate'
import './plugins/vue-currency'
import './plugins/vue-moment'
import 'axios-progress-bar/dist/nprogress.css'
import './plugins/vuetify-datetime-picker'
import './plugins/vue-toast'
import './plugins/pusher'
import './filters'
import './plugins/vue-gates'
import _ from 'lodash'
import { Plugin } from 'vue-fragment'
import './sass/futuraFonts.scss'
import './sass/global.scss'
import './tailwind/output.css'
import * as VueGoogleMaps from 'vue2-google-maps-withscopedautocomp'
Vue.use(Plugin)

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places',
    installComponents: true,
    region: 'PH',
    language: 'es'
  }
})

Vue.prototype._ = _

Vue.config.productionTip = false
Vue.prototype.$http = Axios

Model.$http = Axios

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

Vue.prototype.$http.defaults.headers.common['x-app'] = `B2C`

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places',
    installComponents: true,
    region: 'PH',
    language: 'es'
  }
})
